<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">{{ $t('branch.pageTitle') }}</h1>
      <ts-breadcrumb
        :items="[
          { text: $t('home'), href: '/' },
          {
            text: $t('branch.pageTitle'),
            active: true
          }
        ]"
      />
    </div>
    <ts-card>
      <ts-card-wrapper>
        <div class="d-flex justify-content-end">
          <!-- <ts-button outline color="info" @click.prevent="addNew">
            {{
            $t('add_new')
            }}
          </ts-button> -->
          <div class="d-flex">
            <ts-input
              v-model="search"
              :placeholder="$t('search')"
              style="width: 250px;"
              class="inline-block"
            />
          </div>
        </div>
      </ts-card-wrapper>
      <ts-table :columns="columns" :records="resources" :loading="loading">
        <template v-slot="{ record }">
          <td>{{ record.branch_code }}</td>
          <td>{{ record.branch_name_kh }}</td>
          <td>{{ record.branch_name_en }}</td>
          <td>{{ record.branch_phone }}</td>
          <td>{{ record.branch_email }}</td>
          <td class="text-center">
            <a
              href="#"
              v-tooltip="$t('edit')"
              class="text-primary mr-2"
              @click.prevent="edit(record)"
            >
              <i class="fas fa-edit"></i>
            </a>
            <a-popconfirm
              placement="leftTop"
              :title="$t('are_you_sure_to_delete')"
              :ok-text="$t('yes')"
              :cancel-text="$t('no')"
              @confirm="deleteRecord(record)"
            >
              <a href="#" :disabled="record._deleting">
                <i class="fas fa-circle-notch spin ml-2" v-if="record._deleting"></i>
                <i class="fa fa-trash ml-2 text-red" v-else></i>
              </a>
            </a-popconfirm>
          </td>
        </template>
      </ts-table>
      <div class="d-flex justify-content-end p-15">
        <ts-pagination v-model="pagination" @navigate="fetchData"></ts-pagination>
      </div>
    </ts-card>
  </div>
</template>

<script>
import { debounce } from 'lodash'
import { mapState } from 'vuex'

export default {
  name: 'branchIndex',
  data() {
    return {
      loading: false
    }
  },
  computed: {
    ...mapState('corporate/branch', ['resources', 'pagination']),
    search: {
      get() {
        return this.$store.state.corporate.branch.search
      },
      set(newValue) {
        this.$store.commit('corporate/branch/SET_SEARCH', newValue)
        this.$store.commit('corporate/branch/RESET_CURRENT_PAGE')
      }
    },
    columns() {
      return [
        { name: this.$t('branch.code') },
        { name: this.$t('branch.nameKh') },
        { name: this.$t('branch.nameEn') },
        { name: this.$t('branch.phone') },
        { name: this.$t('branch.email') },
        {
          name: this.$t('actions'),
          style: 'text-align:center; width: 7%;'
        }
      ]
    }
  },
  methods: {
    fetchData(attributes) {
      this.loading = true
      this.$store
        .dispatch('corporate/branch/fetch', { ...attributes })
        .then(response => {
          this.loading = false
        })
        .catch(error => {
          this.loading = false
          this.$toasted.error(error.message)
        })
    },
    addNew() {
      this.$router.push({ name: 'branch-create' })
    },
    edit(record) {
      this.$store.commit('corporate/branch/SET_EDIT_DATA', record)
      this.$router.push({
        name: 'branch-edit',
        params: { id: record.branch_id }
      })
    },
    deleteRecord(record) {
      record._deleting = true
      this.$store
        .dispatch('corporate/branch/destroy', record.branch_id)
        .then(response => {
          this.$toasted.success(response.message)
          this.fetchData()
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          record._deleting = false
        })
    }
  },
  watch: {
    search: debounce(function(search) {
      this.fetchData()
    }, 500)
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.fetchData()
    })
  },
  beforeRouteLeave(to, from, next) {
    this.$store.commit('corporate/branch/RESET_STATE')
    next()
  }
}
</script>
